import { defaultPersonalRoutine } from "./fixtures/personal-routine";

export type RoutineFrequency = "Ogni giorno" | "Ogni settimana" | "Solo il lunedì";

export type PersonalRoutine = {
  name: string;
  frequency: RoutineFrequency;
  time: string;
  instructions: string;
  proposeInChat: boolean;
};

const storageKey = "legal-demo-oggi-routine";
const delay = (ms = 180) => new Promise((resolve) => window.setTimeout(resolve, ms));

export async function getPersonalRoutine(): Promise<PersonalRoutine | null> {
  await delay();
  try {
    const raw = window.localStorage.getItem(storageKey);
    return raw ? (JSON.parse(raw) as PersonalRoutine) : null;
  } catch {
    return null;
  }
}

export async function savePersonalRoutine(routine: PersonalRoutine): Promise<PersonalRoutine> {
  await delay();
  window.localStorage.setItem(storageKey, JSON.stringify(routine));
  return routine;
}

export function getDefaultPersonalRoutine(): PersonalRoutine {
  return { ...defaultPersonalRoutine };
}
